import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["features"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRefWithAs as i, render as p } from '../utils/render.js';
var a = "span";
var s = function (e) {
  return e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e;
}(s || {});
function l(t, r) {
  var n;
  var _t$features = t.features,
    d = _t$features === void 0 ? 1 : _t$features,
    e = _objectWithoutProperties(t, _excluded),
    o = {
      ref: r,
      "aria-hidden": (d & 2) === 2 ? !0 : (n = e["aria-hidden"]) != null ? n : void 0,
      hidden: (d & 4) === 4 ? !0 : void 0,
      style: _objectSpread({
        position: "fixed",
        top: 1,
        left: 1,
        width: 1,
        height: 0,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        borderWidth: "0"
      }, (d & 4) === 4 && (d & 2) !== 2 && {
        display: "none"
      })
    };
  return p({
    ourProps: o,
    theirProps: e,
    slot: {},
    defaultTag: a,
    name: "Hidden"
  });
}
var T = i(l);
export { T as Hidden, s as HiddenFeatures };